
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from './Component/Navbar/Navbar';
import { Route, Routes, useLocation } from 'react-router-dom';
import SignIn from './Pages/SignIn/SignIn';
import Home from './Pages/Home/Home';
import ForgetPassword from './Pages/ForgetPassword/ForgetPassword';
import NewPassWord from './Pages/NewPassWord/NewPassWord';
import Settings from './Pages/Settings/Settings';
import PrivateRoute from './Component/HOC/PrivateRoute';
import Players from './Pages/Players/Players';
import Starter from './Pages/Starter/Starter';
import NotFound from './Pages/NotFound/NotFound';
import UserSetting from './Pages/UserSetting/UserSetting';
import GameLogs from './Pages/GameLogs/GameLogs';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchNotifications } from './redux/actions/notificationActions';
import ControlPageUpdate from './Pages/ControlPageUpdate/ControlPageUpdate';
import { userAuthTrue } from './redux/reducers/fotogritReducer';

function App() {
  const location = useLocation()
  const pathname = location.pathname;
  const token = window.localStorage.getItem("token");

  const dispatch = useDispatch();
  useEffect(() => {
    const user_data = window.localStorage.getItem("user_data");

    dispatch(
      userAuthTrue({
        user: true,
        user_data: JSON.parse(user_data),
      })
    );

  }, [token, dispatch]);
  useEffect(() => {

    dispatch(fetchNotifications());
  }, [location, dispatch, pathname]);



  return (


    <div className='w-full'>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      {
        pathname === "/sign-in"
          || pathname === "/control-page"
          ? null : <Navbar />
      }


      <Routes>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/new-password" element={<NewPassWord />} />
        <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path='/settings' element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path='/user-setting' element={<PrivateRoute><UserSetting /></PrivateRoute>} />
        <Route path='/players/:eventId' element={<PrivateRoute><Players /></PrivateRoute>} />
        <Route path='/starter-substitution/:eventId' element={<PrivateRoute><Starter /></PrivateRoute>} />
        <Route path='/game-logs' element={<PrivateRoute><GameLogs /></PrivateRoute>} />
        <Route path='/control-page' element={<PrivateRoute><ControlPageUpdate /></PrivateRoute>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>

  );
}

export default App;
